import React from 'react';
import { GuestPhotoComponentFragment } from '@graphql/generated';
import { Flex } from '@withjoy/joykit';

interface PhotoProps {
  photoComponentData: GuestPhotoComponentFragment;
}

export const Photo: React.FC<PhotoProps> = ({ photoComponentData }) => {
  return (
    <Flex width="100%" overflow="hidden" borderRadius={3}>
      {photoComponentData.photo.url && <img src={photoComponentData.photo.url} alt={''} width="100%" />})
    </Flex>
  );
};
